module.exports = __webpack_public_path__ + "static/cooler-3424c0338c77f6b5ecc64f85db8be805.webp";